<script>
export default {
    name: 'IconArrowheadRight'
}
</script>
<template>
    <svg
        class="base-icon icon-arrowhead-right"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22.2 8L46 31.9l-.1.099.1.1L22.2 56 18 51.782 37.699 32 18 12.218 22.2 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
